var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82084 24.5641L3.48751 20.5641C3.79804 19.8188 4.52626 19.3334 5.33366 19.3334H22.667C23.4744 19.3334 24.2026 19.8188 24.5131 20.5641L26.1798 24.5641C26.7287 25.8815 25.7608 27.3334 24.3337 27.3334H3.66699C2.23984 27.3334 1.27193 25.8815 1.82084 24.5641Z",
    fill: "#0E308E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.3337 10.1482C23.3337 15.3846 17.5003 22 14.0003 22C10.5003 22 4.66699 15.3846 4.66699 10.1482C4.66699 4.91169 8.84567 0.666687 14.0003 0.666687C19.155 0.666687 23.3337 4.91169 23.3337 10.1482Z",
    fill: "#7291CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 10C17.3337 11.841 15.8413 13.3334 14.0003 13.3334C12.1594 13.3334 10.667 11.841 10.667 10C10.667 8.15907 12.1594 6.66669 14.0003 6.66669C15.8413 6.66669 17.3337 8.15907 17.3337 10Z",
    fill: "#0E308E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c40f176fe4e3b41cd80c5911aa7790bb.svg";
export { ForwardRef as ReactComponent };